import { useEffect } from "react";

/** Sets the tab's title while the page is shown. Null leaves the site name alone, while loading. */
export function usePageTitle(title: string | null) {
  useEffect(() => {
    document.title = title ? `${title} · Kalikaya` : "Kalikaya parts catalogue";
  }, [title]);
}
